import { useState } from "react";
import { toast } from "react-toastify";
import { deleteClient } from "@actions/fetchClientsAction";
import { useAppConfig } from "@context/AppConfigContext";

export const useClientListRenderData = (onClearFilters) => {
  const { user } = useAppConfig();
  const [showDeleteClientDrawer, setShowDeleteClientDrawer] = useState(false);
  const [deleteClientDetails, setDeleteClientDetails] = useState(null);

  const onDeleteClient = (client) => {
    setDeleteClientDetails(client);
    setShowDeleteClientDrawer(true);
  };

  const confirmDeleteClient = async () => {
    try {
      const userData = {
        id: user?.user?.id,
        name: user?.user?.name,
        email: user?.user?.email,
        role: user?.user?.role,
      };

      const result = await deleteClient(
        deleteClientDetails.client_id,
        userData,
      );

      if (result.success) {
        toast.success("Client deleted successfully!");
        setShowDeleteClientDrawer(false);
        setDeleteClientDetails(null);
        onClearFilters();
      } else {
        toast.error(result.message || "Failed to delete client");
      }
    } catch (error) {
      toast.error("Failed to delete client");
      console.error("Error deleting client:", error);
    }
  };

  return {
    onDeleteClient,
    showDeleteClientDrawer,
    setShowDeleteClientDrawer,
    deleteClientDetails,
    confirmDeleteClient,
  };
};
